<template>
<div v-html="project.content.rendered" v-wp-content class="single-project__content"></div>
<div class="thanks">
   <div v-html="footer.premier_texte"></div>
   </div>
   <SimilarProjects :category="getFirstCategory"  :projId="project.id" />
<div class="thanks">
   <div v-html="footer.deuxieme_texte"></div>
</div>
</template>
<script setup lang='ts'>
import type { Project } from '~/types/projects';
import SimilarProjects from './SimilarProjects.vue';

export interface Footer {
  premier_texte:string;
  deuxieme_texte:string;
}
const props = defineProps<{
    project:Project
    footer:Footer
}>()

const getFirstCategory = computed<number | null>(
  () => props.project.categories?.[0] ?? null
)
</script>

<style lang="scss" scoped>
.single-project__content {
  //Video Iframe premier bloc
  .wp-block-embed {
    margin: 0 0 30px 0;
    iframe {
      width: 100%;
      height: 600px;
    }
  }
  .wp-block-image {
    margin: 0;
  }
  // Widget Galerie
  .wp-block-gallery {
    display: grid;
    gap: 1em;
    margin: 0;
    position: relative;
    z-index: 2;
    // Colonnes 1
    &.columns-1 {
      grid-template-columns: 1fr;
    }

    // Colonnes 2
    &.columns-default,
    &.columns-2 {
      grid-template-columns: repeat(2, 1fr);
    }

    // Colonnes 3
    &.columns-3 {
      grid-template-columns: repeat(3, 1fr);
    }

    // Colonnes 4
    &.columns-4 {
      grid-template-columns: repeat(4, 1fr);
    }

    // Colonnes 5
    &.columns-5 {
      grid-template-columns: repeat(5, 1fr);
    }

    // Colonnes 6
    &.columns-6 {
      grid-template-columns: repeat(6, 1fr);
    }
    .wp-block-image {
      margin: 0;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
    }
  }

  //Custom bloc média et texte

  .acf-image-text {
    position: relative;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 70px;
    position: relative;
    padding-bottom: 50px;
    
    &.has-bg {
      &:before {
        content: "";
        background-color: var(--bg-color);
        width: 100vw;
        height: 100%;
        margin-left: calc(-50vw + 50%);
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
      }
    }
    &.overlap {
      margin-top: -6rem;
      margin-bottom: -6rem;
      padding: 150px 0;
      .wp-block-quote {
        bottom: 75px;
      }
    }

    .image-wrapper {
      position: relative;
      z-index: 2;
      height: 600px;
      width: 50%;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .texte-wrapper {
      position: relative;
      z-index: 2;
      width: 50%;
      .text-wrapper__content {
        max-width: 80%;
        margin: auto;
      }
      h2 {
        color: $violet;
        font-size: 20px;
        font-weight: 600;
        text-align: left;
        font-family: "Open Sans", sans-serif;
      }
      p {
        color: $text;
        font-weight: 600;
        text-align: left;
      }
    }
    &[data-ordre="texte-gauche"] .texte-wrapper {
      order: 0;
    }

    &[data-ordre="texte-gauche"] .image-wrapper {
      order: 1;
    }

    &[data-ordre="texte-droite"] .texte-wrapper {
      order: 1;
    }

    &[data-ordre="texte-droite"] .image-wrapper {
      order: 0;
    }
  }

  // Bloc citation
  .wp-block-quote {
    background-color: $violet;
    color: $white;
    padding: 20px;
    position: absolute;
    bottom: 0;
    width: 300px;
    margin: 0;
    transform: matrix(0.99, -0.12, 0.12, 0.99, 0, 0) translateY(-50px);
    z-index: 10;
    cite {
      text-align: center;
      display: block;
    }
    &.is-right {
      right: 0;
    }
    &:before,
    &:after {
      content: '"';
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 700;
      font-size: 30px;
      position: absolute;
    }
    &:before {
      top: 0;
      left: 20px;
    }
    &:after {
      bottom: 0;
      right: 20px;
    }
    p {
      width: 80%;
      margin: auto;
      text-align: center;
      font-weight: 600;
    }
  }

  // Custom bloc Coulisses
  .bloc-coulisses {
    position: relative;
    padding: 20px 0 0 0;
    margin-bottom: 100px;
    &:before {
      content: "";
      background-image: url("~/assets/imgs/fond_1.png");
      background-size: cover;
      width: 100vw;
      height: 90%;
      margin-left: calc(-50vw + 50%);
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      opacity: 0.6;
    }
    h2 {
      position: relative;
      z-index: 2;
      color: $violet;
      margin-bottom: 0;
    }
    &__desc {
      position: relative; 
      z-index: 2;
      p {
        color: $text;
        font-weight: 600;
        font-size: 18px;
        text-align: left;
      }
    }
    &__gallery {
      position: relative;
      z-index: 2;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 40px;
      transform: translateY(60px);
      &:has(> :nth-last-child(1):nth-child(odd)) > :last-child {
        grid-column: 1 / -1;
      }

      @media (max-width: 768px) {
        grid-template-columns: 1fr;
        gap: 24px;
      }
    }

    &__image {
      overflow: hidden;
      transition: transform 0.3s ease;
      margin: 0;
      img {
        display: block;
        width: 100%;
        height: auto;
        object-fit: cover;
        transition: transform 0.3s ease;
      }

      figcaption {
        padding: 0.75rem 1rem;
        font-size: 0.9rem;
        color: #555;
        text-align: center;
      }
    }
  }
}

.thanks{
    margin: 2rem auto;
     :deep(p) {
        color: $violet  !important;
        text-align: center;
        font-style: italic;
        font-weight: 800;
        font-size: 30px;
        @media screen and (max-width:600px) {
          font-size: 22px;
          line-height: 26px;
        }
    }
}
</style>